import React from 'react';
import { formatoMonto } from '../compartidos/useAnalisis';
import { ESTADO_EPISODIO, periodoEpisodio, SEVERIDAD } from './episodioUtils';

// G1: lista compacta, un renglón por episodio. Clic para verlo a la derecha.
export const EpisodioLista = ({ episodios, seleccionado, onSeleccionar }) => (
  <ol className="divide-y divide-slate-100 overflow-hidden rounded-xl border border-slate-200 bg-white" data-testid="episodio-lista">
    {episodios.map((e) => {
      const est = ESTADO_EPISODIO[e.estado] || ESTADO_EPISODIO.VENCIDO;
      const activo = e.id === seleccionado;
      return (
        <li key={e.id}>
          <button type="button" onClick={() => onSeleccionar(e.id)} data-testid={`episodio-fila-${e.id}`}
            className={`w-full border-l-4 px-3 py-2.5 text-left transition-colors ${activo ? 'border-l-sky-600 bg-sky-50' : 'border-l-transparent hover:bg-slate-50'}`}>
            <div className="flex items-center gap-2">
              <span className={`rounded px-1.5 py-0.5 text-[9px] font-bold uppercase ${SEVERIDAD[e.severidad] || 'bg-slate-200 text-slate-700'}`}>{e.severidad || '—'}</span>
              <span className={`truncate text-sm font-medium ${e.estado === 'DESCARTADO' ? 'text-slate-400 line-through' : 'text-slate-800'}`}>{e.monitor}</span>
              <span className={`ml-auto shrink-0 rounded-full border px-2 py-0.5 text-[10px] font-semibold ${est.c}`}>{est.label}</span>
            </div>
            <div className="mt-1 flex items-center gap-3 text-[11px] text-slate-500">
              <span className="font-mono">{periodoEpisodio(e)}</span>
              <span className="ml-auto tabular-nums">{e.cantidad} mov.</span>
              <span className="w-24 text-right font-mono font-semibold text-slate-700">{formatoMonto(e.monto)}</span>
            </div>
          </button>
        </li>
      );
    })}
  </ol>
);

export default EpisodioLista;
